import React from "react"
import withStyles from "react-jss"
import colors from "../data/colors"

const styles = {
  button: {
    fontFamily: "WiredMono",
    fontWeight: 400,
    fontSize: "calc(14px + (20 - 14) * ((100vw - 300px) / (1600 - 300)))",
    padding: "1rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textDecoration: "none",
    textAlign: "center",
    boxSizing: "border-box",
    textTransform: "uppercase",
    backgroundColor: colors.white,
    border: `2px solid ${colors.buttonBlue}`,
    color: colors.buttonBlue,
    transition: `background-color 0.2s ease-in-out,
      color 0.2s ease-in-out`,
    width: "100%",
    maxWidth: "400px",
    marginBottom: "0.5rem",
    "&:hover": {
      color: colors.white,
      backgroundColor: colors.buttonBlue,
    },
    "&:focus": {
      color: colors.white,
      backgroundColor: colors.buttonBlue,
    },
  },
}

const BuyButton = ({ classes, url, text, onClick }) => {
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer nofollow"
      className={classes.button}
      onClick={onClick}>
      {text}
    </a>
  )
}

export default withStyles(styles)(BuyButton)
